module.exports = __webpack_public_path__ + "img/StoreNSaveLogo.cec8c2cb.png";